import { useEffect, useState } from "react";

import { isEmpty } from "@s-libs/micro-dash";

import OverViewContainer from "@/reports/teacher/common/OverViewContainer";
import useInsightsSharedContext from "@/reports/teacher/utils/useInsightsSharedContext/useInsightsSharedContext";
import { CLASSROOM_DATA_REPORT } from "@/reports/teacher/constants";
import { Classroom } from "@/types/models/Classroom.interface";

import PageHeaderContainer from "../../common/PageHeaderContainer";
import ClassroomReadingActivity from "../ClassroomReadingActivity";
import ClassroomReadingSkills from "../ClassroomReadingSkills";
import { pageContentContainerCss } from "./ClassroomMainPage.style";

interface ClassroomMainPageProps {
  /**
   * Boolean check for if experience should render in veiled state for lite, non-trial teachers
   **/
  isVeiled: boolean;
}
const ClassroomMainPage = (props: ClassroomMainPageProps) => {
  const { isVeiled } = props;
  const {
    activeELALicense,
    classrooms,
    selectedFilters,
    navigateToFirstClassroom,
  } = useInsightsSharedContext();

  const [selectedClassroom, setSelectedClassroom] = useState<
    Classroom | undefined
  >();
  const breadcrumbsLinks = [{ contents: CLASSROOM_DATA_REPORT.name }];

  useEffect(() => {
    const selectedClassroomUniqueId = selectedFilters.classroomUniqueId;

    const classroom = classrooms.find(
      (classroom) => classroom.unique_id === selectedClassroomUniqueId,
    );

    if (classroom) {
      setSelectedClassroom(classroom);
    } else {
      navigateToFirstClassroom();
    }
  }, [selectedFilters]);

  const hasNoActiveClassrooms = isEmpty(classrooms) && !isVeiled;
  const hasNoStudentsInClassroom =
    selectedClassroom && isEmpty(selectedClassroom.students);
  return (
    <>
      <PageHeaderContainer
        pageTitle={CLASSROOM_DATA_REPORT.name}
        isClassroomReportPage
        breadcrumbsLinks={breadcrumbsLinks}
        hideFilters={hasNoActiveClassrooms}
      />
      <div css={pageContentContainerCss}>
        <OverViewContainer
          title="Class overview"
          explanationText="Get a snapshot of how your students are reading on Newsela."
          isClassroomPage
          hasNoActiveClassrooms={hasNoActiveClassrooms}
          hasNoStudentsInClassroom={!!hasNoStudentsInClassroom}
        />
        <ClassroomReadingActivity useMockData={isVeiled} />
        {activeELALicense ? (
          <ClassroomReadingSkills useMockData={isVeiled} />
        ) : null}
      </div>
    </>
  );
};

export default ClassroomMainPage;
